
import BankCardInfo from '~/components/calc-block/BankCardInfo.vue';

export default {
  name: 'BanksList',

  props: {
    banks: {
      type: Array,
      default: () => [],
    },
    filteredValues: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BankCardInfo,
  },
  data() {
    return {
      currentBank: null,
      showBanksAmount: 5,
      isShowButton: true,
    }
  },

  computed: {
    onFilterBank: function () {
      const filter = this.filteredValues;

      if (!this.banks || !filter) {
        return [];
      }

      return [...this.banks].filter((item) => {
        const loanAmount = Number(filter.cost || 0) - Number(filter.firstPay || 0);
        const isTerm = Boolean(filter.term >= item.minTerm && filter.term <= item.maxTerm);
        const isCost = Boolean(item.minCost <= loanAmount && loanAmount <= item.maxCost);
        const filterRate = Math.round((filter.interestRate || 0) * 100) / 100;
        const itemRate = Math.round((item.interestRate || 0) * 100) / 100;
        const isInterestRate = filterRate <= itemRate + 0.01;

        return Boolean(isInterestRate && isCost && isTerm);
      });
    }
  },

  methods: {
    setCurrentBank: function (bank) {
      this.currentBank = bank;
    },
    onPatchBank: function (item) {
      if (
        this.currentBank
        && (
          (item.sdelkaHash && this.currentBank.sdelkaHash === item.sdelkaHash)
          || this.currentBank.id === item.id
        )
      ) {
        this.currentBank = item;
      }
      this.$emit('updateBank', item);
    },
    showAllBanks: function () {
      this.showBanksAmount = this.banks.length || 0;
      this.isShowButton = false;
    },
  },
}
